export default {
    baseStyle: {
        requiredIndicator: {
            // reset the chakra default red color
            color: null
        }
    }
}
